import React from 'react';
import Icon from './Icon';
import { SinatraMark } from './SinatraLogo';
import './Sidebar.css';

const VIEWS = [
  { key: 'graph', icon: 'graph', label: 'Graph' },
  { key: 'tree', icon: 'tree', label: 'Tree' },
  { key: 'pipeline', icon: 'pipeline', label: 'Pipeline' },
  { key: 'documents', icon: 'file-text', label: 'Documents' },
  { key: 'dashboard', icon: 'dashboard', label: 'Dashboard' }
];

const TOOLS = [
  { key: 'managers', icon: 'user-check', label: 'Managers', prop: 'onOpenManagers' },
  { key: 'conferencePrep', icon: 'users', label: 'Conference prep', prop: 'onOpenConferencePrep' },
  { key: 'icebreakers', icon: 'graduation-cap', label: 'Icebreakers', prop: 'onOpenIcebreakers' },
  { key: 'pdfImport', icon: 'upload', label: 'Add from PDFs', prop: 'onOpenPdfImport' }
];

/** The app's permanent left-hand nav: which view you're in, and the side tools - always visible,
 * replacing the island's old view-toggle and the ToolsMenu dropdown. Collapsible to an icon rail. */
const Sidebar = (props) => {
  const { viewMode, setViewMode, collapsed, onToggleCollapsed } = props;
  const tools = TOOLS.filter(tool => typeof props[tool.prop] === 'function');

  return (
    <nav className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''}`} aria-label="Navigation">
      <div className="sidebar__brand"><SinatraMark size={18} /></div>

      <div className="sidebar__group">
        {VIEWS.map(view => (
          <button
            key={view.key}
            type="button"
            aria-pressed={viewMode === view.key}
            onClick={() => setViewMode(view.key)}
            className={`sidebar__item ${viewMode === view.key ? 'active' : ''}`}
            title={collapsed ? view.label : undefined}
          >
            <Icon name={view.icon} />
            <span className="sidebar__item-label">{view.label}</span>
          </button>
        ))}
      </div>

      {tools.length > 0 && (
        <>
          <div className="sidebar__divider" aria-hidden="true" />
          <div className="sidebar__group">
            {tools.map(tool => (
              <button
                key={tool.key}
                type="button"
                onClick={props[tool.prop]}
                className="sidebar__item sidebar__item--tool"
                title={tool.label}
              >
                <Icon name={tool.icon} />
                <span className="sidebar__item-label">{tool.label}</span>
              </button>
            ))}
          </div>
        </>
      )}

      <div className="sidebar__spacer" />

      <button
        type="button"
        onClick={onToggleCollapsed}
        className="sidebar__collapse-toggle"
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} />
        <span className="sidebar__item-label">Collapse</span>
      </button>
    </nav>
  );
};

export default Sidebar;
